<template>
  <v-col pa-0 align-self="center">
    <v-row dense align="center" justify="center">
      <v-col pa-0 class="text-center">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn text rounded v-on="on" @click="roll">
              {{ vitalCurrentValue }}
              <v-icon right :color="iconColorString.color"
                >{{ iconColorString.icon }}</v-icon
              >
            </v-btn>
          </template>
          <span>Roll +{{ vitalName }} ({{ vitalCurrentValue }})</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
  export default {
    props: ['vital'],
    name: 'Footervital',
    computed: {
      vitalCurrentValue() {
        return this.$store.getters[`character/${this.vital}Current`];
      },
      vitalName() {
        return `${this.vital.charAt(0).toUpperCase()}${this.vital.slice(1)}`;
      },
      iconColorString() {
        switch (this.vital) {
          case 'health':
            return {
              icon: 'mdi-bottle-tonic-plus-outline',
              color: 'green',
            };
          case 'spirit':
            return {
              icon: 'mdi-ghost',
              color: 'purple',
            };
          case 'supply':
            return {
              icon: 'mdi-bag-personal-outline',
              color: 'brown',
            };
          default:
            return {
              icon: 'mdi-home',
              color: 'blue',
            };
        }
      },
    },
    methods: {
      roll() {
        this.$store.dispatch('character/rollStat', {
          stat: this.vital,
        });
      },
    },
  };
</script>
